import { ChangeEvent, useEffect, useState } from 'react';
import {
  ApprovalStateProps,
  AwaitingSASProps,
  OrderSasData,
  OrderStatusCode,
} from '../interface/interface';
import CustomModal from './CustomModal';
import CollapsibleDataTable from './TableWithCollapsibleRows';
import { addSasBApproval } from '../service/addSasBApproval';
import showToast from './ToastComponent';

const AwaitingSASButton = (props: AwaitingSASProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [approvalData, setApprovalData] = useState<Array<ApprovalStateProps>>(
    [],
  );

  useEffect(() => {
    if (!props?.sasProductData?.length) setApprovalData([]);
    setApprovalData(
      props.sasProductData.map((approval: OrderSasData) => ({
        productId: approval.product.id,
        sasbApprovalId: approval.product.sasbReferenceId as string,
        doctorId: approval.prescription?.prescriberId as number,
      })),
    );
  }, [props?.sasProductData]);

  const handleModalCancelClick = () => {
    setIsModalOpen(false);
    props.handleOrderStatus(undefined);
  };

  const handleSASRefValueChange = (
    e: ChangeEvent<HTMLInputElement>,
    productId: number,
  ) => {
    setApprovalData((prev) => {
      const updatedData = prev.map((item) =>
        item.productId === productId
          ? { ...item, sasbApprovalId: e.target.value }
          : item,
      );

      const isProductExists = prev.some((item) => item.productId === productId);
      return isProductExists
        ? updatedData
        : [
            ...updatedData,
            {
              productId,
              sasbApprovalId: e.target.value,
            },
          ];
    });
  };

  const handleSasApproval = async () => {
    if (!props.accessToken) {
      showToast({
        type: 'warning',
        message: 'Unable to link the reference',
      });
    }
    const responseStatus = await addSasBApproval({
      token: props?.accessToken,
      data: approvalData,
      orderId: props.orderId,
    });
    if (responseStatus === 201) {
      showToast({
        type: 'success',
        message: 'SAS-B References Updated',
      });
    } else {
      showToast({
        type: 'warning',
        message: 'Unable to update SAS-B Reference',
      });
    }
    setIsModalOpen(false);
    props.refreshPage();
  };

  return (
    <>
      <div>
        <CustomModal
          isOpen={isModalOpen}
          onClose={handleModalCancelClick}
          header="Add SAS-B Approval"
          footer={
            <div>
              {approvalData?.length && (
                <button
                  className={`rounded-md text-white text-base px-6 py-3 bg-primary-blue-500`}
                  onClick={() => handleSasApproval()}
                >
                  Save
                </button>
              )}
            </div>
          }
        >
          <CollapsibleDataTable
            data={approvalData?.map((product: ApprovalStateProps) => ({
              hideHiddenColumns: true,
              hasSasNumber: true,
              'Product Name': (
                <div>
                  <p className="text-left">
                    {
                      props?.sasProductData?.find(
                        (products) => products.product.id === product.productId,
                      )?.product?.name
                    }
                  </p>
                </div>
              ),
              'SAS-B Approval Number': (
                <input
                  type="text"
                  value={product.sasbApprovalId}
                  placeholder="Add SAS-B Approval"
                  className="p-2 border border-primary-blue-500 text-sm px-3 py-2 rounded-lg w-3/4"
                  onChange={(e) =>
                    handleSASRefValueChange(e, product.productId)
                  }
                />
              ),
            }))}
            visibleColumns={['Product Name', 'SAS-B Approval Number']}
            hiddenColumns={['Add']}
            sasAddButon={true}
          />
        </CustomModal>
      </div>
      {props.userGroups ? (
        props.orderStatusId === OrderStatusCode.AWAITING_SAS_B && (
          <button
            className={`bg-primary-red-600 text-white p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded mr-6`}
            onClick={() => setIsModalOpen(true)}
          >
            Add SAS-B Approval
          </button>
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default AwaitingSASButton;
